export const getCurrentSynsisalRoute = (): string => {
  const pathName = document.location.pathname.replaceAll('/', ' ')
  if (pathName.trim().length) {
    return `${document.title} |${pathName}`
  }
  return document.title
}
